/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import LoadPanel from "devextreme-react/load-panel";
// export function
import UserTableList from "./UserTable";
import {
  showUser,
  showEmployee,
  IsPermisionOidRequired,
} from "../../../redux/actions";
import {
  responseUser,
  responseEmployee,
  responseMiddleware,
} from "../../../redux/reducers";
import { useDispatch, useSelector } from "react-redux";
// multi language
import UsingIntl from "../../../services/using_intl";
import { formatMessage } from "devextreme/localization";

export default function UserList() {
  const history = useHistory();
  let dataGrid = useRef(null);
  const dispatch = useDispatch();
  const { user, loading: userLoading } = useSelector(responseUser);
  const { employee } = useSelector(responseEmployee);
  const { middleware, loading } = useSelector(responseMiddleware);

  useEffect(() => {
    UsingIntl();
    dispatch(IsPermisionOidRequired());
  }, [dispatch]);

  useEffect(() => {
    if (middleware) {
      const { ReadState, NavigateState } = middleware;
      if (
        (NavigateState !== undefined && !NavigateState) ||
        (ReadState !== undefined && !ReadState)
      ) {
        history.push("/403");
        return;
      }
      dispatch(showUser());
      dispatch(showEmployee());
    }
  }, [middleware]);

  return (
    <div>
      <LoadPanel visible={loading} />
      {userLoading && <LoadPanel visible={userLoading} />}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("UserList")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/permissions" className={"breadcrumb-item"}>
            {formatMessage("Permission")}
          </Link>

          <span className={"breadcrumb-item active"}>
            {formatMessage("UserList")}
          </span>
        </div>
      </div>
      <div className={"section"}>
        <div className={"section-body"}>
          {/* Componnent Table List */}
          <UserTableList
            employee={employee}
            user={user}
            dataGrid={dataGrid}
            middleware={middleware}
          />
        </div>
      </div>
    </div>
  );
}
